class GiftWrapping extends HTMLElement {
  constructor() {
    super();

    this.miniCart = document.querySelector('mini-cart');
    this.giftWrapId = this.dataset.giftWrapId;
    this.giftWrapping = this.dataset.giftWrapping;
    this.cartItemsSize = parseInt(this.getAttribute('cart-items-size'));
    this.giftWrapsInCart = parseInt(this.getAttribute('gift-wraps-in-cart'));
    this.itemsInCart = 1; // Limitando a 1 embrulho para presente

    // Monitorando o checkbox para adicionar ou remover o embrulho
    this.querySelector('[name="attributes[gift-wrapping]"]').addEventListener("change", (event) => {
      if (event.target.checked) {
        this.setGiftWrap(true);  // Adiciona o embrulho se marcado
      } else {
        this.removeGiftWrap();  // Remove o embrulho se desmarcado
      }
    });

    if (this.giftWrapsInCart > 0 && this.giftWrapsInCart != 1) {
      this.setGiftWrap();
    } else if (this.giftWrapsInCart == 0 && this.giftWrapping.length > 0) {
      this.setGiftWrap();
    }
  }

  // Adiciona o embrulho de presente
  setGiftWrap(scrollToMessage = false) {
    const loadingOverlay = this.querySelector('.loading-overlay');
    loadingOverlay.classList.remove('hidden');

    const sections = this.getSectionsToRender().map((section) => section.section);
    const body = JSON.stringify({
      updates: {
        [this.giftWrapId]: 1  // Sempre 1 embrulho
      },
      attributes: {
        'gift-wrapping': true
      },
      sections: sections,
      sections_url: window.location.pathname
    });

    fetch(`${theme.routes.cart_update_url}`, {...fetchConfig(), ...{ body }})
      .then((response) => response.json())
      .then((response) => {
        loadingOverlay.classList.add('hidden');

        if (document.body.classList.contains('template-cart')) {
          window.location.href = theme.routes.cart_url;
          return;
        }

        if (this.miniCart) {
          this.miniCart.renderContents(response);
          if (scrollToMessage) {
            requestAnimationFrame(() => {
              const main = this.miniCart.querySelector('.mini-cart__main');
              const message = main && main.querySelector('.mini-cart__gift-note');
              const shortScreen = window.matchMedia('(max-width: 989px) and (max-height: 600px)').matches;
              const scroller = shortScreen ? this.miniCart.querySelector('.mini-cart__inner') : main;
              if (!message || !scroller) return;

              const scrollerRect = scroller.getBoundingClientRect();
              const messageRect = message.getBoundingClientRect();
              if (messageRect.bottom > scrollerRect.bottom) {
                scroller.scrollTop += messageRect.bottom - scrollerRect.bottom + 8;
              } else if (messageRect.top < scrollerRect.top) {
                scroller.scrollTop += messageRect.top - scrollerRect.top - 8;
              }
            });
          }
        }
      })
      .catch((e) => {
        console.error(e);
      });
  }

  // Remove o embrulho de presente quando o checkbox é desmarcado
  removeGiftWrap() {
    const loadingOverlay = this.querySelector('.loading-overlay');
    loadingOverlay.classList.remove('hidden');

    const sections = this.getSectionsToRender().map((section) => section.section);
    const body = JSON.stringify({
      updates: {
        [this.giftWrapId]: 0  // Remove o único embrulho
      },
      attributes: {
        'gift-wrapping': ''
      },
      sections: sections,
      sections_url: window.location.pathname
    });

    fetch(`${theme.routes.cart_update_url}`, {...fetchConfig(), ...{ body }})
      .then((response) => response.json())
      .then((response) => {
        loadingOverlay.classList.add('hidden');

        if (document.body.classList.contains('template-cart')) {
          window.location.href = theme.routes.cart_url;
          return;
        }

        // Atualiza o conteúdo do carrinho no mini cart
        this.miniCart && this.miniCart.renderContents(response);
      })
      .catch((e) => {
        console.error(e);
      });
  }

  getSectionsToRender() {
    return [
      {
        id: 'mini-cart',
        section: 'mini-cart',
        selector: '.shopify-section'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'mobile-cart-icon-bubble',
        section: 'mobile-cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section'
      }
    ];
  }
}
customElements.define('gift-wrapping', GiftWrapping);
